import { z } from 'zod';

export const directionSchema = z.union([z.literal('up'), z.literal('down')]);

export const roundingPreferenceModelSchema = z.object({
  giftCard: z.object({
    direction: directionSchema,
    nearest: z.number(),
  }),
  merchandise: z.object({
    direction: directionSchema,
    nearest: z.number(),
  }),
  realtimeCardSpend: z.object({
    direction: directionSchema,
    nearest: z.number(),
  }),
});
